import { Check } from "lucide-react";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export function MessageSelectSlot({
    side,
    selected,
    selecting,
    onToggle,
    className,
}: {
    side: "left" | "right";
    selected?: boolean;
    selecting?: boolean;
    onToggle?: () => void;
    className?: string;
}) {
    if (!onToggle) {
        return null;
    }

    return (
        <Button
            type="button"
            size="icon-xs"
            variant="outline"
            aria-pressed={selected}
            aria-label={selected ? "Deselect message" : "Select message"}
            onClick={(event) => {
                event.stopPropagation();
                onToggle();
            }}
            className={cn(
                "absolute top-1/2 z-10 size-5 -translate-y-1/2 rounded-[4px] border-zinc-200 bg-white p-0 shadow-none",
                side === "left" ? "-left-6" : "-right-6",
                selected &&
                    "border-emerald-600 bg-emerald-600 hover:bg-emerald-700 hover:text-white",
                !selecting && !selected && "opacity-0 group-hover/row:opacity-100",
                className,
            )}
        >
            <Check
                className={cn("size-3.5", selected ? "text-white" : "text-zinc-300")}
            />
        </Button>
    );
}
